import { render } from 'preact';
import { App, TSidebarStates } from './app';

import { Router, Route } from 'wouter';
import { ThemeProvider } from './context/theme-context';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { User } from '@novelizing/types';
import { Chapter } from '@novelizing/types';
import { Book } from '@novelizing/types';

// Add type declaration for window.novelizing
declare global {
  interface Window {
    novelizing: {
      book: Book;
      chapter: Chapter;
      chapters: Chapter[];
      user: User;
    };
  }
}

const queryClient = new QueryClient();

const novelizing = window.novelizing;

function renderApp() {
  const container = document.getElementById('reader');

  if (container) {
    container.innerHTML = '';

    render(
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          <Router>
            <Route path="/f/:fictionPermalink/c/:chapterPermalink/:sidebarState?">
              {(params) => {
                // Convert URL parameter to sidebar state
                let sidebarState: TSidebarStates | undefined = undefined;
                if (params.sidebarState === 'chapter-list') {
                  sidebarState = 'chapterList';
                } else if (params.sidebarState === 'comments') {
                  sidebarState = 'comments';
                } else if (params.sidebarState === 'settings') {
                  sidebarState = 'settings';
                }

                return (
                  <App
                    chapterPermalink={params.chapterPermalink}
                    sidebarState={sidebarState}
                    book={novelizing.book}
                    chapter={novelizing.chapter}
                    chapters={novelizing.chapters}
                    user={novelizing.user}
                  />
                );
              }}
            </Route>
          </Router>
        </ThemeProvider>
      </QueryClientProvider>,
      container,
    );
  }
}

renderApp();
